import React from 'react'
import PhoneIcon from '../../Shared/Icons/PhoneIcon.js'
import MailIcon from '../../Shared/Icons/MailIcon.js'
import styles from "../scss/MobileNav.module.scss"

const ContactInfo = () => {
  return (
    <div className={styles.contactInfoContainer}>
          <div className={styles.contactInfo}>
            <PhoneIcon />
            <span>0711111111</span>
          </div>
          <div className={styles.contactInfo}>
            <MailIcon />
            <span>contact@gmail.com</span>
          </div>
        </div>
  )
}

export default ContactInfo